function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSixt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 1000 410"
    },
    viewBox: "0 0 1000 410",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M392.209 78.257c-22.765 2.963-53.386 2.949-78.165 2.737v81.83h46.27c63.236 0 216.362-13.62 262.149-162.824h-97.691c-28.804 56.787-77.985 71.275-132.563 78.257",
    style: {
      fill: "#ff5000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000 64.349v84.522h-95.27v252.786h-99.526V148.87h-74.518l-65.09 92.516 127.521 160.266H669.363L600 307.606l-72.919 94.047-213.042.004V190.505h97.5v203.327L537.04 241.387l-51.668-63.998c7.624-2.543 16.062-5.824 23.284-8.872 23.73-10.02 44.57-25.294 63.22-40.584L600 168.115l75.893-103.766H1000zM134.366 410c97.603-.441 161.247-30.265 161.247-110.508 0-143.559-199.964-82.338-199.964-138.757 0-19.382 21.11-27.185 52.578-27.185 38.548 0 88.272 12.964 126.83 25.452V77.553c-32.021-9.19-77.646-19.642-127.12-19.642C36.506 57.91.127 110.33 0 167.07c-.32 144.028 196.642 82.694 196.642 138.644 0 18.839-20.885 27.302-62.678 27.334-41.137 0-85.115-9.984-130.295-24.889v81.432C28.452 399.657 67.614 410 134.366 410",
    style: {
      fill: "#1a1a1a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSixt);
export default __webpack_public_path__ + "static/media/logo-sixt.961cd1d376ccbaf11cd46f0b0ff2d944.svg";
export { ForwardRef as ReactComponent };